'use client'

import 'posthog-js/dist/customizations.full'
import posthog from 'posthog-js'
import type { BeforeSendFn } from 'posthog-js'
import { PostHogProvider as PostHogReactProvider } from 'posthog-js/react'

declare global {
  interface Window {
    __POSTHOG_INITIALIZED__?: boolean
    posthogCustomizations?: {
      sampleBySessionId?: (percent: number) => BeforeSendFn
    }
  }
}

import { useAuth } from '@/modules/auth/contexts/AuthContext'

interface PostHogProviderProps {
  children: React.ReactNode
}

export default function PostHogProvider({ children }: PostHogProviderProps) {
  const { user } = useAuth()

  if (typeof window !== 'undefined') {
    const posthogKey = 'phc_ux892vxBje1Zg2CK4l5MKOpYIcsLFTx8G2am33b1ou2'
    const posthogHost = 'https://us.i.posthog.com'
    const sampleRateRaw = ''
    const sampleRateValue = sampleRateRaw?.trim()

    if (posthogKey && posthogHost && !window.__POSTHOG_INITIALIZED__) {
      let beforeSend: BeforeSendFn | undefined
      if (sampleRateValue) {
        const parsedSampleRate = Number(sampleRateValue)
        if (Number.isFinite(parsedSampleRate)) {
          const sampleRate = Math.min(1, Math.max(0, parsedSampleRate))
          beforeSend = window.posthogCustomizations?.sampleBySessionId?.(sampleRate)
        }
      }

      posthog.init(posthogKey, {
        api_host: posthogHost,
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: false,
        person_profiles: 'identified_only',
        bootstrap: user ? {
          distinctID: String(user.id),
          isIdentifiedID: true,
        } : undefined,
        ...(beforeSend ? { before_send: beforeSend } : {}),
      })

      window.__POSTHOG_INITIALIZED__ = true
    }
  }

  return (
    <PostHogReactProvider client={posthog}>
      {children}
    </PostHogReactProvider>
  )
}
